/*-----------------------------------------------------------------
- Products Mixin
-----------------------------------------------------------------*/

export default {
    name: 'ProductsMixin',

    methods: {
        /**
         * Add ware item to cart ( in Store )
         *
         * @param {object} ware - ware item
         */
        addToCart(ware) {
            const isLoggedIn = this.$store.getters['auth/isLoggedIn'];
            this.$wait.start('loading-button');

            if (isLoggedIn) {
                this.addItem(ware);
            } else {
                this.$store.dispatch('cart/updateMyCart', [ware]);
                if (ware.count) {
                    this.$toast.success(this.$t('cart.add_to_cart'));
                } else {
                    this.$toast.info(this.$t('cart.delete.success'));
                }
                this.$wait.end('loading-button');
            }
        },

        /**
         * Post ware item to cart ( in Database )
         *
         * @param {object} item - ware item
         * @returns {Promise}
         */
        addItem(item) {
            const { token } = this.$store.getters['auth/state'];
            this.$http.defaults.headers.common.Authorization = `Bearer ${token}`;

            return this.$services.Cart.myOrderAddItem(item).then((response) => {
                this.$toast.success(this.$t('cart.add_to_cart'));
                this.$store.dispatch('cart/emptyCart');
                this.$store.dispatch('cart/updateMyCart', this.get(response.data.results, 'items', []));
            }).catch((error) => {
                this.handleError(error);
            }).finally(() => {
                this.$wait.end('loading-button');
            });
        },
    },
};
